// @ts-nocheck
import 'bootstrap/dist/css/bootstrap.min.css'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import './Home.scss'

// import { useEffect, useState } from 'react'
// import Form from 'react-bootstrap/Form'
// import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Slider from 'react-slick'
import { useEffect, useState } from 'react'
import { trackEvent } from '../../Analytics/GA'
import { butterflyWhite, homephotoalbum, logoNoText } from '../../commonservice'
import { RouteConstants } from '../../Constants/routeConstants'
// import { useAppSelector } from '../../Hooks'
// import { setAddConactResponse } from '../../Redux/slices/userSlice'
// import { addConact } from '../../Redux/thunks'
// import { Regex } from '../../Regex'

const Home = () => {
  const navigate = useNavigate()
  // const dispatch = useDispatch()
  // const [email, setEmail] = useState('')
  // const [message, setMessage] = useState('')
  // const [showSucessMessage, setShowSucessMessage] = useState('')
  // const userState = useAppSelector(state => state.user)
  // const [error, setError] = useState<any>({
  //   emailError: {
  //     state: false,
  //   },
  //   messageError: {
  //     state: false,
  //   },
  // })

  const settings = {
    className: 'bannerSlider',
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const d = new Date()
  const year = d.getFullYear()

  // Removed Contact Us form at bottom 12/07
  // const handleSubmit = () => {
  //   const payload = {
  //     message: message.trim(),
  //     email,
  //   }
  //   dispatch(addConact(payload))
  // }

  // Removed Contact Us form at bottom 12/07
  // useEffect(() => {
  //   if (userState?.addConactResponse?.success === true) {
  //     setShowSucessMessage(userState?.addConactResponse?.message)
  //     setEmail('')
  //     setMessage('')
  //     setTimeout(() => {
  //       setShowSucessMessage('')
  //     }, 3000)
  //     dispatch(setAddConactResponse({ success: null, message: '' }))
  //   }
  // }, [userState?.addConactResponse])
    const [isScrolled, setIsScrolled] = useState(false)


  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY
      if (offset > 50) {
        setIsScrolled(true)
      } else {
        setIsScrolled(false)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div id="HPLandingpage">
      <header className={`Header ${isScrolled ? 'scrolled-header' : ''}`}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="navigationContainer">
                {/* <div className="logo">
                  <picture>
                    <source srcSet={butterflyWhite} media="(min-width: 768px)" />
                    <img src={logoNoText} alt="Butterfly" />
                  </picture>
                </div> */}
                <div className="nav-links">
                  <span 
                    className="nav-link"
                    onClick={() => {
                      navigate('/about-us')
                      trackEvent('Site Interaction', 'About Us Click', 'From Homepage')
                    }}
                  >
                    About Us
                  </span>
                  <span 
                    className="nav-link"
                    onClick={() => {
                      navigate('/contact-us')
                      trackEvent('Site Interaction', 'Contact Us Click', 'From Homepage')
                    }}
                  >
                    Contact Us
                  </span>
                </div>
                <div className="search-icon">
                  <i
                    className="fa fa-search"
                    onClick={() => {
                      navigate('/search')
                      trackEvent('Site Interaction', 'Search Click', 'From Homepage')
                    }}
                  ></i>
                </div>
                <div className="signinIcon">
                  <i
                    className="fa fa-user"
                    onClick={() => {
                      navigate(RouteConstants.LOGIN)
                      trackEvent('Site Interaction', 'Login Click', 'From Homepage')
                    }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div id="Banner">
        <div className="banner-overlay">
          <div className="banner-content">
            <div className="banner-logo">
              <span className="brandLogo">
                LivingLegacy
                <span className="logo-dot">
                  <i className="fa fa-play-circle"></i>
                </span>
                me
              </span>
            </div>
            <h1>Your Life. Your Voice. Your Legacy.</h1>
            <p>Easily add photos, videos, and stories to craft a meaningful and beautiful legacy to last generations.</p>
            <div className="banner-buttons">
              <button
                onClick={() => {
                  navigate('/register')
                  trackEvent('Site Interaction', 'Check Top Legacies Click', 'From Banner')
                }}
                type="button"
                className="getStarted"
              >
                Get Started
              </button>
            </div>
          </div>
          <div className="bannerSliderWrapper">
            <Slider {...settings}>
              {/* <div className="each-slider">
                <img
                  src="https://butterflyv2-production-assets.nyc3.cdn.digitaloceanspaces.com/image/landingpage.jpg"
                  alt="Banner Slider"
                  onClick={() => {
                    navigate(RouteConstants.REGISTER)
                  }}
                />
              </div>
              <div className="each-slider">
                <img
                  src="https://butterflyv2-production-assets.nyc3.digitaloceanspaces.com/image/e6aac589-aec3-495a-aaa1-efe38c69df05-02.jpg"
                  alt="Banner Slider"
                  onClick={() => {
                    navigate(RouteConstants.REGISTER)
                  }}
                />
              </div> */}

              <div className="each-slider">
                <img
                  src="https://butterflyv2-production-assets.nyc3.digitaloceanspaces.com/image/6bd00b7d-eb78-4708-8771-43f86d1a1f9b-03.jpg"
                  alt="Banner Slider"
                  onClick={() => {
                    navigate(RouteConstants.REGISTER)
                  }}
                />
              </div>
              {/* <div className="each-slider">
                <img
                  src="https://butterflyv2-production-assets.nyc3.digitaloceanspaces.com/image/6b1fe038-bd2d-4096-afe2-22417b85a514-04.jpg"
                  alt="Banner Slider"
                  onClick={() => {
                    navigate(RouteConstants.REGISTER)
                  }}
                />
              </div> */}
            </Slider>
          </div>
        </div>
      </div>
      <div id="StorySection">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>Your Story Matters</h2>
              <p>
              No one can tell your story better than you can. Here on LivingLegacy.me
              we use voice technology and guided prompts to help you reflect on and capture the life you lived. 
              By answering meaningful questions our easy-to-use platform will help preserve and enrich your memories and insights for generations to come. 
              </p>
            </div>
            <div className="story-visual">
              <div className="story-card">
                <div className="card-icon">
                  <i className="fa fa-video"></i>
                </div>
                <h3>Create Your Legacy</h3>
                <p>Record your story, wisdom, and memories for future generations</p>
              </div>
              <div className="story-card">
                <div className="card-icon">
                  <i className="fa fa-users"></i>
                </div>
                <h3>Share with Loved Ones</h3>
                <p>No likes or comments just your voice, your memories, and the freedom to share without judgement</p>
              </div>
              <div className="story-card">
                <div className="card-icon">
                  <i className="fa fa-heart"></i>
                </div>
                <h3>Preserve Memories</h3>
                <p>Keep your legacy alive with photos, videos, and stories</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="GetStartedIntro">
        <div className="container">
          <div className="gSinner-holder">
            <div className="lhs-section">
              <h2>LivingLegacy.me is not a social media</h2>
              <p>
              Social media is wonderful for many things. But it doesn't give us the ability to create a story that captures the essence and breadth of a life. That deep personal experience is what inspired the creator of LivingLegacy.me to build this special place.
              </p>
              <p>
                LivingLegacy.me was created as timeless space where memories aren't just shared but carefully preserved. Where stories can be relived and added to over time. Where you and loved ones can return to again and again to reflect, remember and celebrate a meaningful life.
              </p>
             
              {/* <button
                type="button"
                onClick={() => {
                  navigate('/search')
                  trackEvent('Site Interaction', 'Check Top Legacies Click', 'From Intro Section')
                }}
                className="getStarted"
              >
                SEARCH
              </button> */}
            </div>
            <div className="rhs-section">
              <div className="inner-wrapper">
                <div className="each-card">
                  <div className="icon">
                    <i className="fa fa-link" aria-hidden="true"></i>
                  </div>
                  <div className="content">
                    <h3>Your Feed is Special</h3>
                    <p>
                      It turns emotions into an uplifting narrative, brought to life with photos and videos, and the
                      stories that connect them.
                    </p>
                  </div>
                </div>
                <div className="each-card">
                  <div className="icon">
                    <i className="fa fa-link" aria-hidden="true"></i>
                  </div>
                  <div className="content">
                    <h3>Thoughtful Prompts</h3>
                    <p>
                    We understand it can be difficult to know where to start.
                    That's why we provide you useful prompts to help you get started
                    </p>
                  </div>
                </div>
                {/* <div className="each-card">
                  <div className="icon">
                    <i className="fa fa-eventsicon" aria-hidden="true"></i>
                  </div>
                  <div className="content">
                    <h3>Events, Too</h3>
                    <p>
                      Butterfly is also where memorial services and celebrations of life can be shared with those in
                      your circle of remembrance.
                    </p>
                  </div>
                </div> */}
                <div className="each-card">
                  <div className="icon">
                    <i className="fa fa-link" aria-hidden="true"></i>
                  </div>
                  <div className="content">
                    <h3>Gallery</h3>
                    <p>
                      Turn your memories into a mesmerizing montage, bringing together photos and videos to form a
                      captivating visual narrative.
                    </p>
                  </div>
                </div>
               
                {/* <div className="each-card">
                  <div className="icon">
                    <i className="fa fa-fundraiser" aria-hidden="true"></i>
                  </div>
                  <div className="content">
                    <h3>Fundraiser</h3>
                    <p>
                      Honor life&apos;s significant moments by rallying support and gathering resources for a cause that
                      touches your heart, making a positive impact in the process.
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="pAlbum-holder">
            <div className="lhs-section">
              <img src={homephotoalbum} alt="Photo Album" />
            </div>
            <div className="rhs-section">
              <h3>Life is Lived In Moments</h3>
              <p>
              We hear from our Legacy community the pages they 
              create are deeply meaningful in how they capture the vibrancy of 
              an individual, and the tapestry of their lives. Creating a time capsule of their true essence and being able to share it with the people that matter most- forever.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="PreFooter">
        <div className="content">
          <h3>Your Life. Your Voice. Your Lessons.</h3>
          <button
            onClick={() => {
              navigate('/register')
              trackEvent('Site Interaction', 'Check Top Legacies Click', 'From Pre-Footer')
            }}
            type="button"
            className="getStarted"
          >
            Get Started
          </button>
          {/* {showSucessMessage ? ( // REMOVED CONTACT US FORM
              <div className="contactus-message">{showSucessMessage}</div>
            ) : (
              <Form>
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label>
                    Email Address<sup>*</sup>
                  </Form.Label>
                  <Form.Control
                    required
                    value={email}
                    isInvalid={error.emailError.state}
                    type="email"
                    onChange={e => {
                      setEmail(e.currentTarget.value)
                      if (!e.currentTarget.value) {
                        setError((prevState: any) => {
                          return {
                            ...prevState,
                            emailError: {
                              message: 'Email is required',
                              state: true,
                            },
                          }
                        })
                      } else if (!e.currentTarget.value.match(Regex.email)) {
                        setError((prevState: any) => {
                          return {
                            ...prevState,
                            emailError: {
                              message: 'Email is not valid',
                              state: true,
                            },
                          }
                        })
                      } else {
                        setError({
                          ...error,
                          emailError: {
                            state: false,
                          },
                        })
                      }
                    }}
                    onBlur={e => {
                      if (!e.currentTarget.value) {
                        setError((prevState: any) => {
                          return {
                            ...prevState,
                            emailError: {
                              message: 'Email is required',
                              state: true,
                            },
                          }
                        })
                      } else if (!e.currentTarget.value.match(Regex.email)) {
                        setError((prevState: any) => {
                          return {
                            ...prevState,
                            emailError: {
                              message: 'Email is not valid',
                              state: true,
                            },
                          }
                        })
                      }
                    }}
                  />
                  {error.emailError.state && (
                    <Form.Control.Feedback type="invalid">{error.emailError.message}</Form.Control.Feedback>
                  )}
                </Form.Group>
                <Form.Group className="mb-4" controlId="formBasicPassword">
                  <Form.Label>
                    Message<sup>*</sup>
                  </Form.Label>
                  <Form.Control
                    required
                    value={message}
                    isInvalid={error.messageError.state}
                    as="textarea"
                    onChange={e => {
                      setMessage(e.currentTarget.value)
                      if (!e.currentTarget.value) {
                        setError((prevState: any) => {
                          return {
                            ...prevState,
                            messageError: {
                              message: 'Message is required',
                              state: true,
                            },
                          }
                        })
                      } else {
                        setError({
                          ...error,
                          messageError: {
                            state: false,
                          },
                        })
                      }
                    }}
                    onBlur={e => {
                      if (!e.currentTarget.value) {
                        setError((prevState: any) => {
                          return {
                            ...prevState,
                            messageError: {
                              message: 'Message is required',
                              state: true,
                            },
                          }
                        })
                      }
                    }}
                  />
                  {error.messageError.state && (
                    <Form.Control.Feedback type="invalid">{error.messageError.message}</Form.Control.Feedback>
                  )}
                </Form.Group>
                <button
                  className="sendMessage"
                  disabled={!email || !message ? true : (true && error.emailError.state) || error.messageError.state}
                  type="button"
                  onClick={() => {
                    handleSubmit()
                  }}
                >
                  Send message
                </button>
              </Form>
            )} */}
        </div>
      </div>
      <footer className="Footer">
        <div className="container">
          <ul>
            <li>Contact | Henry Scott CEO bigfatcoupon@gmail.com</li>
            <li>
              <a target="_blank" href={RouteConstants.TERMCONDITION} rel="noreferrer">
                Terms of Service
              </a>
            </li>
            <li>
              <a target="_blank" href={RouteConstants.PRIVACYPOLICY} rel="noreferrer">
                Privacy Policy
              </a>
            </li>
            <li>© {year} Living Legacy Co. All rights reserved</li>
          </ul>
          <p
            className="hidden-link"
            onClick={() => {
              navigate(RouteConstants.PUBLICPAGES)
            }}
          >
            Pages
          </p>
        </div>
      </footer>
    </div>
  )
}

export default Home
